import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../../../contexts/LanguageContext';
import { panelStyle } from './DashboardPanel';
import { ACCENT } from '../utils/dashboardUtils';

const RequestedTrainingsCard = ({ pendingCount }) => {
    const { th } = useLanguage();

    return (
        <div className="p-4 flex flex-column align-items-center text-center gap-2" style={{ ...panelStyle, backgroundColor: '#FEF3F2', borderColor: '#FEE4E2' }}>
            <div className="relative flex align-items-center justify-content-center border-circle mb-2" style={{ width: '5rem', height: '5rem', backgroundColor: '#FEE4E2' }}>
                <i className="pi pi-file-edit" style={{ fontSize: '2rem', color: '#101828' }} />
                {pendingCount > 0 && (
                    <span
                        className="absolute flex align-items-center justify-content-center border-circle text-xs font-bold"
                        title={th('lmsDashboard.requests.pendingTooltip')}
                        style={{ top: '-0.25rem', right: '-0.25rem', minWidth: '1.6rem', height: '1.6rem', padding: '0 0.3rem', backgroundColor: ACCENT, color: '#FFFFFF' }}
                    >
                        {pendingCount > 99 ? '99+' : pendingCount}
                    </span>
                )}
            </div>
            <span className="font-bold" style={{ color: '#101828', textTransform: 'uppercase', letterSpacing: '0.02em' }}>
                {th('lmsDashboard.requests.title')}
            </span>
            <span className="text-sm mb-2" style={{ color: '#475467' }}>
                {th('lmsDashboard.requests.description')}
            </span>
            <Link
                to="/learning-management-system/training-request"
                className="no-underline w-full flex align-items-center justify-content-center gap-2 font-semibold p-3 border-round-lg"
                style={{ backgroundColor: '#FFFFFF', border: '1px solid #D0D5DD', color: '#101828' }}
            >
                {th('lmsDashboard.requests.viewRequests')}
                <i className="pi pi-arrow-right" style={{ fontSize: '0.8rem' }} />
            </Link>
        </div>
    );
};

export default RequestedTrainingsCard;
